import apiClient from '@/services/api';

const API_URL = '/companies';

export default {
  async getCompanies()            { const r = await apiClient.get(API_URL); return r.data; },
  async getCompany(id)           { const r = await apiClient.get(`${API_URL}/${id}`); return r.data; },
  async createCompany(data)      { const r = await apiClient.post(API_URL, data); return r.data; },
  async updateCompany(id, data)  { const r = await apiClient.put(`${API_URL}/${id}`, data); return r.data; },
  async deleteCompany(id)        { return apiClient.delete(`${API_URL}/${id}`); }
};
